import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthorizeService } from './authorize.service';
import { LoginPath, QueryParameterNames } from './api-authorization.constants';

@Injectable({
	providedIn: 'root'
})
export class AuthorizeGuard implements CanActivate, CanActivateChild {
	private authorize = inject(AuthorizeService);
	private router = inject(Router);

	canActivate(
		_next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean> {
		return this.checkAuth(state);
	}

	canActivateChild(
		_next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean> {
		return this.checkAuth(state);
	}

	private checkAuth(state: RouterStateSnapshot): Observable<boolean> {
		return this.authorize.authState$.pipe(
			filter(s => s !== 'unknown'),
			take(1),
			map(s => {
				if (s === 'authenticated') return true;
				this.router.navigate(LoginPath, {
					queryParams: { [QueryParameterNames.ReturnUrl]: state.url }
				});
				return false;
			})
		);
	}
}
